import React from 'react';
import styles from './anyErrorPopup.module.scss';
import classNames from 'classnames/bind';
import Modal from '@common/modal';
import Button from '@components/common/button';

const cx = classNames.bind(styles);

export const AnyErrorPopup = () => {
  const handleClickExit = () => {
    window.close();
    setTimeout(() => alert('페이지를 벗어나시려면 우측 상단의 X 버튼을 클릭해 주세요.'), 100);
  };
  const handleClickRestart = () => window.location.reload();
  return (
    <Modal visible>
      <div className={cx('modal')}>
        <div className={cx('title')}>
          면접 진행 중 오류가 발생하였습니다. <br />
          확인 후 다시 시도해 주세요.
        </div>
        <div className={cx('description')}>종료 시 이어하기를 통해 다시 연습을 진행하실 수 있습니다.</div>
        <div className={cx('footer')}>
          <Button theme="secondary" onClick={handleClickRestart} styles={{ width: 168, height: 48 }}>
            다시 시작
          </Button>
          <Button onClick={handleClickExit} styles={{ width: 168, height: 48 }}>
            종료
          </Button>
        </div>
      </div>
    </Modal>
  );
};
